import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.goToHome = this.goToHome.bind(this);
  }

  goToHome() {
    window.location.href = 'https://superfarm.com/#/';
  }

  goToWallet = () => {
    window.location.href = `https://superfarm.com/#/wallets/${this.props.account}`;
  };

  async connectWallet() {
    await window.connectWallet();
  }

  formatAddress(connectedAddress) {
    if (connectedAddress) {
      const shortenedAddress = connectedAddress.substring(0, 6) + '...' + connectedAddress.substring(connectedAddress.length - 4);
      return shortenedAddress;
      // If the user has not connected to a signing address, return no label.
    } else {
      return '';
    }
  }

  render() {
    return (
      <div className='header'>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25 39' onClick={this.goToHome}>
          <path d='M14.2 13.5C17 14.5 18.9 15.5 20.6 16.7 22.9 14.1 23 10.6 22.8 8.3 20.9 10.6 18 12.4 14.2 13.5Z'></path>
          <path d='M0.6 37.7C2.5 35 5.1 34.4 9.6 33.3 11.4 32.9 13.3 32.4 15.7 31.7 21.3 30 22.7 26.9 23.1 25.2 23.6 22.9 22.7 20.5 21 19.1 17.2 16 13.5 14.7 8 13.6L6.9 13.3 8.1 13.2C14.8 12.3 19.5 10.2 22 6.7 23.9 4.1 24 1.5 24 0.3 22.5 2.6 19.5 3.3 14.8 4.4 12.9 4.9 10.7 5.4 8.2 6.2 2.6 7.8 1.2 10.9 0.9 12.7 0.4 14.9 1.2 17.3 2.9 18.8 6.7 21.9 10.4 23.1 15.9 24.2L17.1 24.5 15.9 24.6C12.5 25.1 9.2 25.8 6.6 26.7 3.4 27.8 1.4 29.2 0.6 30.8 -0.5 33 0.2 36.5 0.6 37.7Z'></path>
        </svg>

        {this.props.account === '' ? (
          <button className='wallet_button' onClick={this.connectWallet}>
            <svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M8.59 11.41C9 11.8 9 12.44 8.59 12.83C8.2 13.22 7.56 13.22 7.17 12.83C6.23338 11.892 5.70731 10.6206 5.70731 9.295C5.70731 7.96942 6.23338 6.69803 7.17 5.76L10.71 2.22C11.648 1.28338 12.9194 0.757309 14.245 0.757309C15.5706 0.757309 16.842 1.28338 17.78 2.22C18.7166 3.15803 19.2427 4.42942 19.2427 5.755C19.2427 7.08058 18.7166 8.35197 17.78 9.29L16.29 10.78C16.3 9.96 16.17 9.14 15.89 8.36L16.36 7.88C16.6403 7.60269 16.8629 7.27253 17.0148 6.90863C17.1667 6.54473 17.2449 6.15432 17.2449 5.76C17.2449 5.36568 17.1667 4.97527 17.0148 4.61137C16.8629 4.24747 16.6403 3.91731 16.36 3.64C16.0827 3.35966 15.7525 3.13711 15.3886 2.98522C15.0247 2.83333 14.6343 2.75512 14.24 2.75512C13.8457 2.75512 13.4553 2.83333 13.0914 2.98522C12.7275 3.13711 12.3973 3.35966 12.12 3.64L8.59 7.17C8.30966 7.44731 8.08711 7.77747 7.93522 8.14137C7.78333 8.50527 7.70512 8.89568 7.70512 9.29C7.70512 9.68433 7.78333 10.0747 7.93522 10.4386C8.08711 10.8025 8.30966 11.1327 8.59 11.41V11.41ZM11.41 7.17C11.8 6.78 12.44 6.78 12.83 7.17C13.7666 8.10803 14.2927 9.37942 14.2927 10.705C14.2927 12.0306 13.7666 13.302 12.83 14.24L9.29 17.78C8.35197 18.7166 7.08058 19.2427 5.755 19.2427C4.42942 19.2427 3.15803 18.7166 2.22 17.78C1.28338 16.842 0.757309 15.5706 0.757309 14.245C0.757309 12.9194 1.28338 11.648 2.22 10.71L3.71 9.22C3.7 10.04 3.83 10.86 4.11 11.65L3.64 12.12C3.35966 12.3973 3.13711 12.7275 2.98522 13.0914C2.83333 13.4553 2.75512 13.8457 2.75512 14.24C2.75512 14.6343 2.83333 15.0247 2.98522 15.3886C3.13711 15.7525 3.35966 16.0827 3.64 16.36C3.91731 16.6403 4.24747 16.8629 4.61137 17.0148C4.97527 17.1667 5.36568 17.2449 5.76 17.2449C6.15432 17.2449 6.54473 17.1667 6.90863 17.0148C7.27253 16.8629 7.60269 16.6403 7.88 16.36L11.41 12.83C11.6903 12.5527 11.9129 12.2225 12.0648 11.8586C12.2167 11.4947 12.2949 11.1043 12.2949 10.71C12.2949 10.3157 12.2167 9.92527 12.0648 9.56137C11.9129 9.19747 11.6903 8.86731 11.41 8.59C11.3129 8.49899 11.2355 8.38903 11.1825 8.2669C11.1296 8.14478 11.1023 8.0131 11.1023 7.88C11.1023 7.7469 11.1296 7.61522 11.1825 7.4931C11.2355 7.37097 11.3129 7.26101 11.41 7.17V7.17Z'
                fill='currentColor'
              ></path>
            </svg>
            Connect Wallet
          </button>
        ) : (
          <button className='profile_button' onClick={this.goToWallet}>
            <div className='profile-image'></div>
            <p>{this.formatAddress(this.props.account)}</p>
          </button>
        )}
      </div>
    );
  }
}

export default Header;
